import React from 'react'

export default function CheckBoxAddEspecialist({assignDay, label}) {

  return (
    <div>
        <label className='f-14 text-gray'
        ><input  onClick={assignDay} type="checkbox" id="cbox1" value="first_checkbox" />{label}</label><br />
    </div>
  )}
